import { Box, Button, Text } from "@chakra-ui/react";
import { PlusCircle } from "@phosphor-icons/react";
import { H4 } from "components/text/headings";
import { colors } from "theme/foundations/colors";

/**
 * Chunky button for "Create New Thing" with a plus icon and a title and text
 * @param {*} param0
 * @returns
 */
export default function CreateButton({ title, text, onClick }) {
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      bgColor="lightLime"
      borderColor={colors.lime}
      py="50px"
      paddingLeft="20px"
      paddingRight="20px"
      justifyContent="flex-start"
    >
      <Box display="flex" direction="row" alignItems="center" gap={4} justifyContent="flex-start">
        <Box>
          <PlusCircle size={32} color={colors.darkTeal} />
        </Box>
        <Box alignItems="flex-start" textAlign="left" whiteSpace="normal">
          <H4 color="teal">{title}</H4>
          <Text color="teal" fontWeight="normal" mt={2}>
            {text}
          </Text>
        </Box>
      </Box>
    </Button>
  );
}
